module.exports = __webpack_public_path__ + "img/ic_order.dc197a2e.svg";